type ProductStockData = { stock?: number | null } | null | undefined;
type ProductStockInput = ProductStockData | ProductStockData[];

export function getProductStockLimit(product_stock: ProductStockInput): number {
  if (product_stock === null || product_stock === undefined) {
    return Infinity;
  }
  let stockVal: number | null | undefined;
  if (Array.isArray(product_stock)) {
    if (product_stock.length === 0) return Infinity;
    stockVal = product_stock[0]?.stock;
  } else {
    stockVal = product_stock.stock;
  }

  if (stockVal === null || stockVal === undefined) {
    return Infinity;
  }

  const num = Number(stockVal);
  return Number.isNaN(num) ? Infinity : num;
}

export function isProductOutOfStock(product_stock: ProductStockInput): boolean {
  const stock = getProductStockLimit(product_stock);
  return stock <= 0;
}

export function shouldShowProduct(product: { visible?: boolean | null; product_stock?: ProductStockInput }): boolean {
  if (product.visible === false) return false;
  if (isProductOutOfStock(product.product_stock)) return false;
  return true;
}
